export enum Tjenesterelasjon {
  Produsent = 'PRODUSENT',
  Leverandoer = 'LEVERANDOER'
}
